// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import Err from './Err.vue'

Vue.use(MintUI)
Vue.config.productionTip = false
//隐藏KK导航栏
if(window.kk){
    kk.ready(function () {
        kk.app.hideTitleBar();
    });
}

export default new Vue({
    el: '#app',   
    template: '<Err/>',
    components: {Err},
    data: {
        deviceType: ''
    },
    created() {
        let ua = window.navigator.userAgent;
        if (ua.match(/Android/)) {
            this.deviceType = 'android'
        }
        if (ua.match(/(iPhone|iPad)/)) {
            this.deviceType = 'ios'
        }
    },
    mounted() {
        (function () { // 调试代码
            var src = '//cdn.jsdelivr.net/npm/eruda';
            if (!/eruda=true/.test(window.location) && localStorage.getItem('active-eruda') != 'true') return;
            document.write('<scr' + 'ipt src="' + src + '"></scr' + 'ipt>');
            document.write('<scr' + 'ipt>eruda.init();</scr' + 'ipt>');
        })()
    },
    methods: {
        goKKPage() {
            if(window.kk) {
                kk.app.exit();
            }
        },
        dataLoading() {
            this.$indicator.open({
                text: '加载中...',
                spinnerType: 'snake'
            });
        },
        dataLoaded() {
            this.$indicator.close()
        },

        toIndex() {
            this.$router.push('/')
            window.location.reload()

        }
        

    }
})





// WEBPACK FOOTER //
// ./src/error.js